import { render, staticRenderFns } from "./RegionSideNav.vue?vue&type=template&id=342a8b84"
import script from "./RegionSideNav.vue?vue&type=script&lang=js"
export * from "./RegionSideNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports